var _style, _path, _path2, _g, _g2, _g3, _g4, _defs, _path3, _path4, _g5, _g6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWaterIcon = function SvgWaterIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_2_);}\n\t.st2{fill:#FFFFFF;fill-opacity:0.25;}\n\t.st3{fill:#50AFF1;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_3_);filter:url(#Adobe_OpacityMaskFilter);}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_4_);}\n\t.st7{mask:url(#mask0_1_);}\n\t.st8{fill:#4CA1DB;}\n\t.st9{fill:#FFFFFF;fill-opacity:0.6;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.9017,
    y1: 26.8,
    x2: 7.9017,
    y2: 4.0055,
    gradientTransform: "matrix(1 0 0 -1 0 28.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9ED6FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66BAF4"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.2,2c-0.2,0-0.5,0.1-0.6,0.3c-2.1,2.3-7.9,8.9-8,13.5c-0.1,5.1,3.8,8.9,8.6,9V2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.5315,
    y1: 26.8,
    x2: 16.5315,
    y2: 4.0055,
    gradientTransform: "matrix(1 0 0 -1 0 28.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9ED6FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66BAF4"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.2,2c0.2,0,0.5,0.1,0.6,0.3c2.1,2.3,7.9,8.9,8,13.5c0.1,5.1-3.8,8.9-8.6,9V2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 14,
    cy: 18.8,
    rx: 9.6,
    ry: 7.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M6.6,9.4c-0.9,1.4-3.3,4.9-2.4,8.6C4.3,16.7,4,14.2,6.6,9.4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M18.7,11.3c1.4,3,2.3,9.8-5.3,12.7C16,22.7,20.8,18.4,18.7,11.3z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6,10.7C5,11.9,3,16.1,4.8,19.3C4.7,17.7,5.3,13.1,6,10.7z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 3.5,
    y: 9.2,
    width: 17.1,
    height: 15.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 3.5,
    y: 9.2,
    width: 17.1,
    height: 15.5,
    id: "mask0_1_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.9017,
    y1: 26.8,
    x2: 7.9017,
    y2: 4.0055,
    gradientTransform: "matrix(1 0 0 -1 0 28.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9ED6FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66BAF4"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12.2,2c-0.2,0-0.5,0.1-0.6,0.3c-2.1,2.3-7.9,8.9-8,13.5c-0.1,5.1,3.8,8.9,8.6,9V2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.5315,
    y1: 26.8,
    x2: 16.5315,
    y2: 4.0055,
    gradientTransform: "matrix(1 0 0 -1 0 28.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9ED6FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66BAF4"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M12.2,2c0.2,0,0.5,0.1,0.6,0.3c2.1,2.3,7.9,8.9,8,13.5c0.1,5.1-3.8,8.9-8.6,9V2z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M19.7,12c1.4,3,2.3,9.8-5.3,12.7C17,23.4,21.8,19.1,19.7,12z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M5.7,21.7c-1.6-2.3-3.3-5.7-1.1-10c0.4-1.1,0.9-2,1.7-2.5c-0.7,0.9-1.3,1.7-1.7,2.5 C3.7,14.3,3.9,18.2,5.7,21.7z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M17.9,10c0.3-0.5-1.1-2.1-1.8-2.9c0.3,0.7,1,2.2,1.1,2.5C17.2,9.9,17.5,10.5,17.9,10z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWaterIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/water_icon.f24378a9.svg";
export { ForwardRef as ReactComponent };